import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { LineChart } from '@mui/x-charts/LineChart';
import type React from 'react';

import getIndustryColor from '../../constants/industryColors';
import type { IndustryChartData } from '../../utils/chartDataUtils';

interface IndustryLineChartProps {
  title: string;
  industryData: IndustryChartData[];
  totalLineData: IndustryChartData | null;
  monthLabels: string[];
  yAxisLabel?: string;
  height?: number;
}

const IndustryLineChart: React.FC<IndustryLineChartProps> = ({
  title,
  industryData,
  totalLineData,
  monthLabels,
  yAxisLabel,
  height = 400,
}) => {
  const theme = useTheme();

  const series = [
    ...(totalLineData
      ? [
          {
            data: totalLineData.data,
            label: totalLineData.industry,
            color: getIndustryColor('Total', theme),
          },
        ]
      : []),
    ...industryData.map((item) => ({
      data: item.data,
      label: item.industry,
      color: getIndustryColor(item.industry, theme),
    })),
  ] as Array<{ data: number[]; label: string; color: string }>;

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
          {title}
        </Typography>
        <LineChart
          series={series}
          xAxis={[
            {
              data: monthLabels,
              scaleType: 'point',
            },
          ]}
          height={height}
          margin={{ top: 20, bottom: 60, left: yAxisLabel ? 90 : 60, right: 80 }}
          yAxis={
            yAxisLabel
              ? [
                  {
                    label: yAxisLabel,
                  },
                ]
              : undefined
          }
          slotProps={{
            legend: {
              position: {
                vertical: 'top',
                horizontal: 'end',
              },
            },
          }}
        />
      </CardContent>
    </Card>
  );
};

export default IndustryLineChart;
